import { useCallback, useEffect, useMemo } from 'react';
import { useController, useForm } from 'react-hook-form';
import { AddressType } from '../../models';

export type EditAddressNotesForm = {
  intercomName: string;
  floor: number;
  hasElevator: boolean;
  notes: string;
  addressType?: AddressType;
};

export const useEditAddressNotesValidationForm = (
  notes?: EditAddressNotesForm
) => {
  const {
    register,
    handleSubmit,
    setValue: setFormValue,
    control,
    formState: { errors },
  } = useForm<EditAddressNotesForm>({
    defaultValues: {
      addressType: notes?.addressType,
      floor: notes?.floor,
      hasElevator: notes?.hasElevator,
      intercomName: notes?.intercomName,
      notes: notes?.notes,
    },
  });

  useEffect(() => {
    notes &&
      notes.addressType &&
      setFormValue('addressType', notes.addressType);
    notes && notes.floor && setFormValue('floor', notes.floor);
    notes &&
      notes.hasElevator &&
      setFormValue('hasElevator', notes.hasElevator);
    notes &&
      notes.intercomName &&
      setFormValue('intercomName', notes.intercomName);
    notes && notes.notes && setFormValue('notes', notes.notes);
  }, [notes, setFormValue]);

  const { field: addressTypeField } = useController<
    EditAddressNotesForm,
    'addressType'
  >({
    control,
    name: 'addressType',
    defaultValue: AddressType.Private,
  });

  const onAddressTypeChange = useCallback(
    (val: AddressType) => {
      setFormValue('addressType', val, { shouldValidate: true });
    },
    [setFormValue]
  );

  const intercomNameValidation = useMemo(
    () => register('intercomName'),
    [register]
  );

  const floorValidation = useMemo(() => register('floor'), [register]);

  const hasElevatorValidation = useMemo(
    () => register('hasElevator'),
    [register]
  );

  const notesValidation = useMemo(() => register('notes'), [register]);

  return {
    notesValidation,
    floorValidation,
    hasElevatorValidation,
    intercomNameValidation,
    addressTypeField,
    onAddressTypeChange,
    errors,
    handleSubmit,
  };
};
